type TemplateData = Record<string, string | number | undefined | null>;

export function renderTemplate(template: string, data: TemplateData) {
  return template.replace(/\{([a-zA-Z0-9_]+)\}/g, (_, key) => String(data[key] ?? ""));
}

export function openWhatsApp(phone: string | undefined, message: string) {
  const cleanPhone = String(phone || "").replace(/\D/g, "");
  const url = cleanPhone
    ? `https://wa.me/55${cleanPhone}?text=${encodeURIComponent(message)}`
    : `https://wa.me/?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank", "noopener,noreferrer");
}

export const defaultWhatsAppTemplates = [
  {
    nome: "Confirmação de consulta",
    tipo: "Agendamento",
    mensagem: "Olá, {paciente}! Confirmamos seu agendamento para {data} às {horario}. Clínica: {clinica}.",
  },
  {
    nome: "Lembrete de consulta",
    tipo: "Agendamento",
    mensagem: "Olá, {paciente}! Passando para lembrar sua consulta em {data} às {horario}.",
  },
  {
    nome: "Retorno",
    tipo: "Retorno",
    mensagem: "Olá, {paciente}! Já podemos agendar seu retorno. Qual melhor dia para você?",
  },
  {
    nome: "Cobrança",
    tipo: "Financeiro",
    mensagem: "Olá, {paciente}! Consta um pagamento pendente de {valor}, com vencimento em {vencimento}.",
  },
  {
    nome: "Orçamento",
    tipo: "Orçamento",
    mensagem: "Olá, {paciente}! Seu orçamento/plano de tratamento está disponível no valor de {valor}.",
  },
  {
    nome: "Aniversário",
    tipo: "Relacionamento",
    mensagem: "Olá, {paciente}! A equipe da clínica deseja um feliz aniversário e muita saúde!",
  },
];
